<template>
  <div style="padding: 20px">
    <div style="padding-bottom: 20px">
      <el-input placeholder="请输入姓名" v-model="query.info" style="width: 160px;padding-right: 10px"></el-input>
      <select-area @areaListId="getAreaListId"/>
      <el-date-picker
          v-model="query.yearAndMonth"
          type="month"
          style="width: 160px;margin-right: 10px"
          value-format="YYYY-MM"
          placeholder="年月选择">
      </el-date-picker>
      <el-button type="primary" @click="getData()">搜索</el-button>
      <el-popconfirm @confirm="exportExcel" title="确定要导出吗？">
        <template #reference>
          <el-button type="primary" icon="Download">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '16px' }"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header">
      <el-table-column prop="region" label="城市"></el-table-column>
      <el-table-column prop="regionType" label="城市类型"></el-table-column>
      <el-table-column prop="coachName" label="姓名"></el-table-column>
      <el-table-column prop="coachState" label="状态"></el-table-column>
      <el-table-column prop="orderCount" label="当月订单量"></el-table-column>
      <el-table-column prop="sendCount" label="合同发送量"></el-table-column>
      <el-table-column prop="signCount" label="合同签署量"></el-table-column>
      <el-table-column prop="rateStr" label="合同签署率"></el-table-column>
      <el-table-column label="详情" width="100" fixed="right" align="center">
        <template #default="scope">
          <el-button @click="detailDialog=true , detail = scope.row.detail" size="small" style="padding: 0;margin: 0" type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <el-dialog
        title="详情"
        draggable
        v-model="detailDialog"
        width="1300px">
      <el-table height="500px"
                :data="detail"
                border
                class="table"
                ref="multipleTable"
                :row-style="{ height: 10 + 'px' }"
                :cell-style="{ padding: 5 + 'px' }"
                header-cell-class-name="table-header"
      >
        <el-table-column prop="studentId" label="学员ID" width="100" show-overflow-tooltip />
        <el-table-column prop="studentName" label="学员姓名" width="100" show-overflow-tooltip />
        <el-table-column prop="region" label="城市" width="100" show-overflow-tooltip />
        <el-table-column prop="area" label="区域" width="100" show-overflow-tooltip />
        <el-table-column prop="campus" label="校区" width="160" show-overflow-tooltip />
        <el-table-column prop="regionType" label="类型" width="120" show-overflow-tooltip />
        <el-table-column prop="cardType" label="课程" width="160" show-overflow-tooltip />
        <el-table-column prop="type" label="卡类型" width="120" show-overflow-tooltip />
        <el-table-column prop="coachName" label="教练" width="120" show-overflow-tooltip />

        <el-table-column prop="tradingMoney" label="交易金额" width="120" show-overflow-tooltip />
        <el-table-column prop="tradingTime" label="交易时间" width="180" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />

        <el-table-column prop="state" label="卡状态" width="100" show-overflow-tooltip />
        <el-table-column prop="contractStateStr" label="合同状态" width="120" show-overflow-tooltip />

<!--        <el-table-column prop="sendId" label="副卡ID" width="120" show-overflow-tooltip />-->
<!--        <el-table-column prop="sendCardType" label="副卡课程名称" width="140" show-overflow-tooltip />-->
<!--        <el-table-column prop="sendState" label="副卡状态" width="120" show-overflow-tooltip />-->
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import selectArea from "../../components/SelectArea";
import {selectCoachContractPage,exportCoachContract} from "../../api/orders";
export default {
  components: {
    selectArea
  },
  name: "Contract",
  data() {
    return {
      detail:[],
      detailDialog:false,
      coachList:[],
      tableData:[],
      tableLoading:false,
      query: {
        info:"",
        pageIndex: 1,
        pageSize: 10,
        pageTotal:0,
        year:null,
        month:null,
        yearAndMonth:null
      }
    }
  },
  methods: {
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    exportExcel() {
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      exportCoachContract(this.query).then(val=>{
        if (val.code == 200) {
          this.$message.success("下载中，请稍后前往右上角下载中心查看！");
        }else {
          this.$message.error(val.message);
        }
      });
    },
    getData(){
      this.tableLoading = true;
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      selectCoachContractPage(this.query).then(val=>{
        if (val.code == 200) {
          this.tableLoading = false;
          this.tableData = val.data.records;
          this.query.pageTotal = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    },
    getAreaListId(val) {
      this.query.areaList = val;
    },
  },
  created() {
    this.getData();
  }
}
</script>

<style scoped>

</style>